export const REFER_A_FRIEND_INVITATION_PAGE = 'refer-a-friend-invitation'

export const REFER_A_FRIEND_INVITATION_PAGE_WITHOUT_LOCALE =
  'refer-a-friend-invitation-without-locale'
